module dm.portal.services {
    angular.module("dm.portal.services", []);
}